/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import { createReducer, createAction } from '@reduxjs/toolkit';
import { CourierList, CourierObject } from '@/types';

export interface ShippingInfoInitialState {
  pickedCourier: CourierList;
}

export const initialState: ShippingInfoInitialState = {
  pickedCourier: {
    name: '',
    rate_code: '',
    price: 0,
    duration: '',
    duration_unit: '',
    currency: '',
    courier: [],
    isChecked: false,
  },
};

const SET_PICKED_COURIER = 'SET_PICKED_COURIER';

export const getShippingInfoState: (
  state: ShippingInfoInitialState
) => ShippingInfoInitialState = (state: ShippingInfoInitialState) => state;

export const setPickedCourier = createAction(
  SET_PICKED_COURIER,
  (payload: CourierList) => ({
    payload,
  })
);

export default createReducer(initialState, {
  [SET_PICKED_COURIER]: (state, action) => {
    state.pickedCourier = action.payload;
  },
});
